import { Component, Input } from '@angular/core';
import { magicPreviewDummyData } from '../../../classes/company';

@Component({
  selector: 'aira-number',
  templateUrl: './aira-number.component.html',
  styleUrl: './aira-number.component.css',
})
export class AiraNumberComponent {
  @Input() label;
  @Input() value;
  @Input() prepend = '';
  @Input() append = '';
  @Input() displayFormat = '';
  @Input() previewOnly: boolean = false;

  ngOnInit() {
    if (this.previewOnly) {
      this.value = magicPreviewDummyData.numberSimple;
    }
  }
}
